import { XMarkIcon } from '@heroicons/react/24/outline';

import { Button } from '@oysterjs/ui/button';

import { RENEWAL_BANNER_INNER, RENEWAL_BANNER_SHELL } from './annual-renewal';
import { formatRenewalShortDate } from './renewal-migration-shared';

import { getStandardPlanRenewalDate, SubscriptionRenewalDates } from './renewal-billing-date';

export const RenewalMigrationBanner = ({
  agencyName,
  subscription,
  onReviewOptions,
  readOnly
}: {
  agencyName: string;
  subscription?: SubscriptionRenewalDates | null;
  onReviewOptions?: () => void;
  readOnly?: boolean;
}) => {
  const renewalDateObject = getStandardPlanRenewalDate(subscription);
  const renewalDate = formatRenewalShortDate(renewalDateObject);
  const showRenewalDate = renewalDateObject && renewalDateObject >= new Date(2026, 7, 1);

  return (
    <div className={RENEWAL_BANNER_SHELL}>
      <div className={RENEWAL_BANNER_INNER}>
        <div className="flex items-center justify-between gap-4">
          <h3 className="m-0 p-0 text-lg font-medium text-neutral-50">
            Cara Standard is being retired
          </h3>
          {!readOnly && (
            <Button color="white" onClick={onReviewOptions} className="shrink-0">
              Review renewal options
            </Button>
          )}
        </div>
        <div className="mt-3 max-w-2xl space-y-1.5 text-sm leading-relaxed text-neutral-200">
          {showRenewalDate && (
            <p className="m-0">
              <strong className="text-white">{agencyName}</strong> renews on{' '}
              <strong className="text-white">{renewalDate}</strong>.
            </p>
          )}
          <p className="m-0">
            Review your plan and billing options before then. Cara Pro is the default unless you
            choose Cara Basic.
          </p>
          <p className="m-0">
            You&apos;ll automatically receive <span className="font-semibold">10% off</span> with
            monthly billing or <span className="font-semibold">20% off</span> with annual billing.
          </p>
        </div>
      </div>
    </div>
  );
};

export const RenewalMigrationThankYouBanner = ({
  planLabel,
  periodLabel,
  seats,
  billingStartLabel,
  onDismiss
}: {
  planLabel: string;
  periodLabel: string;
  seats: number;
  billingStartLabel: string;
  onDismiss?: () => void;
}) => (
  <div className="overflow-hidden rounded-lg bg-gradient-to-r from-emerald-700 to-emerald-600">
    <div className={RENEWAL_BANNER_INNER}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="m-0 text-base font-semibold text-white">
            Thank you for confirming your renewal
          </p>
          <p className="mt-1.5 m-0 text-sm leading-relaxed text-emerald-50">
            <span className="font-semibold text-white">
              {planLabel} · {periodLabel} · {seats} {seats === 1 ? 'seat' : 'seats'}
            </span>
            {' — first charge on '}
            <span className="font-semibold text-white">{billingStartLabel}</span>.
          </p>
        </div>
        {onDismiss && (
          <button
            type="button"
            aria-label="Dismiss"
            onClick={onDismiss}
            className="shrink-0 rounded-md p-1 text-neutral-100 hover:bg-white/10 hover:text-white"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  </div>
);
